var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError500(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 49.5C57 47.0147 54.9853 45 52.5 45H24C15.7157 45 9 38.2843 9 30C9 21.7157 15.7157 15 24 15L33 15V21L24 21C19.0294 21 15 25.0294 15 30C15 34.9706 19.0294 39 24 39H52.5C58.299 39 63 43.701 63 49.5C63 55.299 58.299 60 52.5 60H12C10.3431 60 9 58.6569 9 57C9 55.3431 10.3431 54 12 54H52.5C54.9853 54 57 51.9853 57 49.5Z",
    fill: "#FF794D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 9H48V15H60C61.6569 15 63 13.6569 63 12C63 10.3431 61.6569 9 60 9Z",
    fill: "#36575F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 21H48V27H60C61.6569 27 63 25.6569 63 24C63 22.3431 61.6569 21 60 21Z",
    fill: "#36575F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 12H39C35.6863 12 33 14.6863 33 18C33 21.3137 35.6863 24 39 24H48V12ZM39 6C32.3726 6 27 11.3726 27 18C27 24.6274 32.3726 30 39 30H51C52.6569 30 54 28.6569 54 27V9C54 7.34315 52.6569 6 51 6H39Z",
    fill: "#36575F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError500);
export default __webpack_public_path__ + "static/media/error_500.4bd7b61fa5ae755fa2d49d432520db7a.svg";
export { ForwardRef as ReactComponent };